export const preventCopy = (e) => {
  e.preventDefault();
  e.nativeEvent.stopImmediatePropagation();
  return false;
};
